import { useTranslation } from 'react-i18next';

export const useDisplayConfigurationMessageTitle = (index: number): string => {
  const { t } = useTranslation();
  return `${t('customMessage')} ${index + 1}`;
};
